import React, { Component, useState } from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../../components/Navbar'
import Spinner from '../../components/Spinner'
import Api from '../../services/Api'
import { storeCookies } from '../../services/Utility'
import { useNavigate } from 'react-router-dom';

function Login() {
  const [isOtp, setOtp] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [emailAddress, setEmailAddress] = useState()
  const [otpValue, setOtpValue] = useState()
  const navigate = useNavigate()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const obj = {
      email_address: emailAddress
    }
    const objOtp = {
      email_address: emailAddress,
      otp: otpValue
    }
    if (isOtp) {
      setLoading(true)
      const data = await Api.verifyOtp(objOtp);
      if (data.err == true) {
        setLoading(false)
        alert(data.msg)
      }
      else {
        setLoading(false)
        storeCookies("auth-token", data.data.data.token)
        storeCookies("tenant-id", data.data.data.tenant_id)
        storeCookies("isAdmin", data.data.data.role ? data.data.data.role : "user")
        if(data.data.data.role === 'admin') {
          navigate("/dashboard/Projects")
        }
        else {
          navigate("/dashboard/DataSubjectTypes")          
        }      
      }
    }
    else {
      setLoading(true)
      const data = await Api.generateOtp(obj);
      if (data.err == true) {
        setLoading(false)
        alert(data.msg)
      }
      else {
        setOtp(true)
        setLoading(false)
      }
    }

  }
  const handleEmailChange = (e) => {
    setEmailAddress(e.target.value);
  }
  const handleOtpChange = (e) => {
    setOtpValue(e.target.value);
  }
  return (
    <div>
      <div style={{ height: '100vh' }} className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img className="mx-auto h-12 w-auto" src="images/R2Logo.png" alt="R2 Consulting" />
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Welcome to <Link to="/"><span className='text-blue-600'>Data Privacy</span></Link> portal</h2>
            <br />
            <p style={{ textAlign: 'center' }}>Please enter your email address to login</p>
          </div>
          <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" value="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email-address" className="sr-only">Email address</label>
                <input id="email-address" name="email" type="email"
                  onChange={handleEmailChange}
                  autoComplete="email" required className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm" placeholder="Email address" />
              </div>
              {isOtp &&
                <div className='otp-div'>
                  <label htmlFor="otp" className="sr-only">Login Code</label>
                  <input id="otp" name="otp" onChange={handleOtpChange}
                    required className="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm" placeholder="OTP" />
                </div>
              }
            </div>
            <div>
              <button type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-blue-900 py-2 px-4 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg className="h-5 w-5 text-blue-500 group-hover:text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd" />
                  </svg>
                </span>
                {isOtp ? "Verify and Sign in" : "Generate Login Code"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <small>&copy; <a href="https://www.r2c.io" rel='noreferrer' target="_blank">R2 Consulting</a> {(new Date()).getFullYear()}</small>
      </div>
      {isLoading &&
        <Spinner />}
    </div>

  )

}
export default Login;
